export default {
    "planemission" : {
        "titles": "Emissão de plantas",
        "label": "Plantas",
        "description": "As plantas de localização foram geradas com sucesso.",
        "list_title": "Plantas Emitidas:",
        "help": {
            "define_area": "@:emissions.help.define_area",
            "draw_on_map": "@:emissions.help.draw_on_map",
            "select_process": "Seleccione o mapa que deseja emitir",
        },
        "error": {
            "invalid_form": "@:emissions.error.invalid_form",
        },
        "buttons": {
            "next": "@:emissions.buttons.next",
            "previous": "@:emissions.buttons.previous",
            "finish": "@:emissions.buttons.finish",
            "close": "@:emissions.buttons.close",
        },
    },
    "pmdfciemission" : {
        "titles": "Planos PMDFCI",
        "label": "PMDFCI",
        "description": "As plantas do PMDFCI - Plano Municipal da Defesa da Floresta Contra Incêndios, foram geradas com sucesso.",
        "list_title": "Plantas Emitidas:",
        "form": {
            "title": "Informação a constar nas plantas",
        },
        "help": {
            "define_area": "Definir as áreas relativas à pretensão",
            "draw_on_map": "Efectue o desenho sobre o mapa da delimitação da pretensão, nomeadamente, <strong>@:pmdfciemission.upload.filterBoundaryTitle</strong> e <strong>área de @:pmdfciemission.upload.filterClaimTitle</strong> existentes, a construir e/ou a ampliar, utilizando as seguintes ferramentas disponibilizadas para o efeito:",
            "select_process": "Seleccione a planta que deseja emitir",
            "notes": {
                "title": "Notas:",
                "first_line": "Deve desenhar em <strong>1º</strong> o polígono relativo aos <strong>@:pmdfciemission.upload.filterBoundaryTitle</strong>",
                "second_line": "Em <strong>2º</strong>, desenhe o polígono com a <strong>área de @:pmdfciemission.upload.filterClaimTitle</strong>",
            }
        },
        "upload": {
            "filterBoundaryTitle": "Limites da Propriedade",
            "filterClaimTitle": "Implantação do Edifício",
        },
        "error": {
            "invalid_form": "@:emissions.error.invalid_form",
        },
        "buttons": {
            "next": "@:emissions.buttons.next",
            "previous": "@:emissions.buttons.previous",
            "finish": "@:emissions.buttons.finish",
            "close": "@:emissions.buttons.close",
        },
    },
    "administrativeprocessemission" : {
        "titles": "Processos Administrativos",
        "label": "Processos",
        "description": "O processo administrativo foi gerado com sucesso.",
        "list_title": "Plantas Emitidas:",
        "form": {
            "title": "Informação a constar no processo administrativo",
            "parent_work_type_id": "Grupo",
            "work_type_id": "Natureza de Obra"
        },
        "help": {
            "define_area": "@:emissions.help.define_area",
            "draw_on_map": "@:emissions.help.draw_on_map",
            "select_process": "Seleccione o processo administrativo que deseja emitir",
        },
        "buttons": {
            "next": "@:emissions.buttons.next",
            "previous": "@:emissions.buttons.previous",
            "finish": "@:emissions.buttons.finish",
            "close": "@:emissions.buttons.close",
        },
    },
    "pisemission" : {
        "titles": "Pedido de Informação Simples",
        "label": "Confrontar",
        "description": "O Pedido de Informação Simples foi gerado com sucesso.",
        "list_title": "Plantas Emitidas:",
        "form": {
            "title": "Informação a constar no pedido de informação simples",
        },
        "help": {
            "define_area": "@:emissions.help.define_area",
            "draw_on_map": "@:emissions.help.draw_on_map",
        },
        "buttons": {
            "next": "@:emissions.buttons.next",
            "previous": "@:emissions.buttons.previous",
            "finish": "@:emissions.buttons.finish",
            "close": "@:emissions.buttons.close",
        },
        "error": {
            "invalid_form": "@:emissions.error.invalid_form",
        },
    },
    "emissions": {
        "buttons": {
            "next": "Seguinte",
            "previous": "Voltar",
            "finish": "Processar",
            "close": "Fechar",
        },
        "actions": {
            "draw": "Desenhar",
            "import": "Importar",
        },
        "error": {
            "import_fail": 'Não foi possível importar nenhuma geometria. Por favor, consulte os detalhes para importação.',
            "invalid_form": "@:global.msg.error.form"
        },
        "help": {
            "define_area": "Definir no mapa a área da pretensão",
            "draw_on_map": "Efectue um desenho sobre o mapa utilizando as seguintes ferramentas disponibilizadas para o efeito:",
            "select_process": "Seleccione o processo administrativo que deseja emitir",
        },
        "form": {
            "name": "Nome",
            "email": "E-mail",
            "address": "Local",
            "obs": "Observações",
            "featureable": {
                "title": "Elementos",
            }
        }
    },
}
